import React from "react";
import validator from "validator";
import { v4 as uuidv4 } from 'uuid';
import {injectIntl} from "react-intl";
import {deleteCookie, getCookie, setCookie} from "../lib/utils";
import MSStreamLoader from "./ms-stream-loader.jsx";
import MsPanelButton from "./ms-panel-button.jsx";
import MsField from "./ms-field.jsx";
import MSStreamPurchase from "./ms-stream-purchase.jsx";

class MSStreamLogin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.token = null;
    this.wcData = (this.props.wcdata) ? this.props.wcdata.split('--'): "0--0--0";
    this.prodData = {
      cur: this.wcData[0],
      price: Number(this.wcData[1]).toFixed(2),
      tax: this.wcData[2],
      title: this.props.streamName,
    };
    this.state = {
      screen: "initial",
      errorMessage: "",
      firstTime: true,
      emailSent: false,
      showPanel: false,
      isLogged: false,
      isRegistered: false,
      addCart: false,
      goPayment: false,
      firstName: "",
      firstNameError: false,
      lastName: "",
      lastNameError: false,
      email: "",
      emailError: false,
      password: "",
      passwordError: false,
      customFields: [],
      customFieldsValues: {},
      purchaseScreen: false,
      firstNameErrMsg:"",
      lastNameErrMsg: "",
      emailErrMsg: "",
      passwErrMsg: "",
    }
    this.userData = {};
    this.extraData = {};
    this.setEmail = this.setEmail.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.setFirstName = this.setFirstName.bind(this);
    this.setLastName = this.setLastName.bind(this);
    this.setCustomField = this.setCustomField.bind(this);
    this.showLogin = this.showLogin.bind(this);
    this.showRegister = this.showRegister.bind(this);
    this.buildModal = this.buildModal.bind(this);
    this.getExtraFields = this.getExtraFields.bind(this);
    this.registrationModal = this.registrationModal.bind(this);
    this.buildRegistrationModal = this.buildRegistrationModal.bind(this);
    this.streamTitle = this.streamTitle.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.registerNow = this.registerNow.bind(this);
    this.loginLink = this.loginLink.bind(this);
    this.lostPassword = this.lostPassword.bind(this);
    this.loginUser = this.loginUser.bind(this);
    this.login = this.login.bind(this);
    this.createAccount = this.createAccount.bind(this);
    this.createAcc = this.createAcc.bind(this);
    this.confirmLogin = this.confirmLogin.bind(this);
    this.registerUser = this.registerUser.bind(this);
    this.sendLostPassword = this.sendLostPassword.bind(this);
    this.goBack = this.goBack.bind(this);
    this.buildLoginHeader = this.buildLoginHeader.bind(this);
    this.buildLoginModal = this.buildLoginModal.bind(this);
    this.buildSingUpModal = this.buildSingUpModal.bind(this);
    this.buildLostPassword = this.buildLostPassword.bind(this);
    this.isLoggedIn = this.isLoggedIn.bind(this);
    this.logOut = this.logOut.bind(this);
    this.viewStream = this.viewStream.bind(this);
  }

  componentDidMount() {
    // todo jonas cookie
    this.token = getCookie('itrn-msjwbtn');
    //console.log("TOKEN:", this.token);
    if (this.token && this.token != "") {
      this.isLoggedIn((resp) => {
        if (!resp || !resp.success || !resp.data) {
          deleteCookie('itrn-msjwbtn');
          this.token = null;
          this.userData = {};
          this.setState({ isLogged: false, isRegistered: false, firstTime: true });
          this.getExtraFields();
          return;
        }
        this.setState({
          isRegistered: Boolean(resp.data.reg),
          isLogged: true,
          firstTime: false
        });
        this.getExtraFields();
      });
    } else {
      this.getExtraFields();
    }
  }

  logOut() {
    deleteCookie("itrn-msjwbtn");
    this.setState({isLogged : false, isRegistered: false, firstTime: true});
    this.userData = {};
    this.goBack();
  }

  isLoggedIn(callback) {
    console.log("TOKEN:", this.token);
    if (this.token && this.token != "") {
      this.props.restMS.restRequest('vt',
        { auth: this.token },
        (resp) => {
          if (resp.success && resp.data && (resp.data.ptr || resp.data.reg)) {
            this.userData = resp.data.reg ? resp.data.rtr : resp.data.ptr;
          }
          if (callback)
            callback (resp);
        },
        (err) => {
          if (callback)
            callback (err);
        });
      return true;
    } else {
      return false;
    }
  }

  setEmail(newEmail) {
    this.setState({email: newEmail});
  }

  setPassword(newPassword) {
    this.setState({password: newPassword});
  }

  setFirstName(newFirstName) {
    this.setState({firstName: newFirstName});
  }

  setLastName(newLastName) {
    this.setState({lastName: newLastName});
  }

  setCustomField(newField, customKey) {
    let customFieldsValues = {}
    Object.keys(this.state.customFieldsValues).forEach((key) => {
      customFieldsValues[key] = {};
      if (key == customKey) {
        customFieldsValues[key].value = newField;
      } else {
        customFieldsValues[key].value = this.state.customFieldsValues[key].value;
      }
      customFieldsValues[key].error = this.state.customFieldsValues[key].error;
    });
    this.setState({customFieldsValues: customFieldsValues});
  }

  addToCart() {
    if (this.state.isLogged) {
      this.setState({showPanel: true, goPayment: true, purchaseScreen: true})
    } else {
      this.setState({showPanel: true, screen: "login", addCart: true, goPayment: true});
    }
  }

  showLogin() {
    let fieldsValues = {};
    this.state.customFields.forEach((it) => {
      fieldsValues[it.name] = {value: "", error: false}
    });
    this.setState({
      showPanel: true,
      screen: "login",
      errorMessage: "",
      customFieldsValues: fieldsValues,
      firstName: "",
      firstNameError: false,
      lastName: "",
      lastNameError: false,
      email: "",
      emailError: false,
      password: "",
      passwordError: false});
  }

  showRegister() {
    let fieldsValues = {};
    this.state.customFields.forEach((it) => {
      fieldsValues[it.name] = {value: "", error: false}
    });
    this.setState({
      showPanel: true,
      screen: "register",
      errorMessage: "",
      customFieldsValues: fieldsValues,
      firstName: "",
      firstNameError: false,
      lastName: "",
      lastNameError: false,
      email: "",
      emailError: false,
      password: "",
      passwordError: false});
  }

  registerNow() {
    if (this.state.isLogged) {
      this.registerUser();
    } else {
      this.setState({showPanel: true, screen: "login", addCart: true});
    }
  }

  loginLink() {
    this.setState({showPanel: true, screen: "login", addCart: false});
  }

  lostPassword() {
    this.setState({showPanel: true, screen: "lost-password"});
  }

  loginUser() {
    let allOk = true;
    this.setState({
      showPanel: false,
      errorMessage: "",
      emailError: false,
      passwordError: false
    });
    if (this.state.email == ""){
      allOk = false;
      this.setState({emailError: true});
    }
    if (this.state.password == ""){
      allOk = false;
      this.setState({passwordError: true});
    }
    if(!allOk) {
      this.setState({
        showPanel: true,
        errorMessage: "Missing Information"
      });
      return;
    } else if (!validator.isEmail( this.state.email )) {
      this.setState({
        showPanel: true,
        emailError: true,
        errorMessage: "Invalid Email"
      });
      return;
    }

    let authData = btoa(this.state.email) + '-' + btoa(this.state.password);
    this.login(authData);
  }

  createAccount() {
    let allOk = true;
    Object.keys(this.state.customFieldsValues).forEach((key) => {
      this.state.customFieldsValues[key].error =  false;
    });
    this.setState({
      showPanel: false,
      errorMessage: "",
      firstNameError: false,
      lastNameError: false,
      emailError: false,
      passwordError: false,
      customFieldsValues: this.state.customFieldsValues
    });
    let authData = {
      first_name: btoa(this.state.firstName),
      last_name: btoa(this.state.lastName),
      email: btoa(this.state.email),
      password: btoa(this.state.password)
    }

    if (this.state.firstName == ""){
      allOk = false;
      this.setState({firstNameError: true});
    }
    if (this.state.lastName == ""){
      allOk = false;
      this.setState({lastNameError: true});
    }
    if (this.state.email == ""){
      allOk = false;
      this.setState({emailError: true});
    }
    if (this.state.password == ""){
      allOk = false;
      this.setState({passwordError: true});
    }
    this.state.customFields.forEach((it) => {
      authData[it.name] = btoa(this.state.customFieldsValues[it.name].value);
      if (this.state.customFieldsValues[it.name].value == "" && it.mandatory == "1") {
        allOk = false;
        this.state.customFieldsValues[it.name].error = true;
        this.setState({customFieldsValues: this.state.customFieldsValues});
      }
    });

    if(!allOk) {
      this.setState({
        showPanel: true,
        emailError: true,
        errorMessage: "Missing Information"
      });
      return;
    } else if (!validator.isEmail( this.state.email )) {
      this.setState({
        showPanel: true,
        emailError: true,
        errorMessage: "Invalid Email"
      });
      return;
    }

    this.createAcc(authData);
  }

  createAcc(authData) {
    let authStg = uuidv4() + '-' + btoa(JSON.stringify(authData));
    // console.log('---------> authData', authData);
    // console.log('---------> authStg', authStg);
    this.props.restMS.restRequest('re', {
        auth: btoa(authStg)
      },
      (resp) => {
        this.confirmLogin(resp, 'register');
      },
      (err) => {
        this.setState({
          showPanel: true,
          errorMessage: "Account not created."
        });
      });
  }

  login(authData) {
    this.props.restMS.restRequest('le', {auth: authData},
      (resp) => {
        this.confirmLogin(resp, 'login');
      },
      (err) => {
        console.log('------>', err);
        this.setState({
          showPanel: true,
          errorMessage: "Error to login."
        });
      }
    );
  }

  confirmLogin(resp, _check_type ) {
    console.log( 'message', resp );
    if (!resp.success) {

      if( _check_type == 'register' ) {
          const fieldErrors = resp.data && typeof resp.data === 'object' ? resp.data : {};
          const emailMsg = fieldErrors.email || (typeof resp.data === 'string' ? resp.data : '');
          this.setState({
            showPanel: true,
            errorMessage: emailMsg || 'Account not created.',
            emailError: Boolean(emailMsg),
            emailErrMsg: emailMsg,
            firstNameError: Boolean(fieldErrors.first_name),
            firstNameErrMsg: fieldErrors.first_name || '',
            lastNameError: Boolean(fieldErrors.last_name),
            lastNameErrMsg: fieldErrors.last_name || '',
          });
      } else {
        const loginData = resp.data && typeof resp.data === 'object' ? resp.data : {};
        const loginMsg = loginData.msg || loginData.email || (typeof resp.data === 'string' ? resp.data : '');
        this.setState({
          showPanel: true,
          errorMessage: loginMsg || 'Error to login.',
          emailError: Boolean(loginData.email),
          emailErrMsg: loginData.email || '',
        });
      }

      
      if (resp.data.show_captcha && this.state.screen == 'login') {
        console.log('--------> DO RECaptcha');
      }
      return;
    }
    setCookie("itrn-msjwbtn", resp.data.tkn, 1);
    this.token = resp.data.tkn;
    if (this.state.addCart) {
      if (resp.data.reg) {
        this.userData = resp.data.rtr;
        setCookie("itrn-jwescax", resp.data.rtr.id, 1);
        this.setState({ isLogged : true, isRegistered: true, firstTime: false});
        this.goBack();
      } else if (resp.data.ptr) {
        // once log successfull set cookie for userId
        setCookie("itrn-jwescax", resp.data.ptr.id, 1);

        this.userData = resp.data.ptr;
        if (this.state.goPayment) {
          this.setState({ showPanel: true, isLogged : true, purchaseScreen: true});
        } else {
          this.registerUser();
        }
      }
    } else {
      if (resp.data.ptr) {
        // once log successfull set cookie for userId
        setCookie("itrn-jwescax", resp.data.ptr.id, 1);
        this.userData = resp.data.ptr;
        this.setState({ isLogged : true});
      } else if ( resp.data.reg) {
        this.userData = resp.data.rtr;
        // once log successfull set cookie for userId
        setCookie("itrn-jwescax", resp.data.rtr.id, 1);
        this.setState({ isLogged : true, isRegistered: true, firstTime: false});
      }
      this.goBack();
    }
  }

  registerUser() {
    this.setState({
      showPanel: false
    })
    this.props.restMS.restRequest('rs',
      { auth: this.token },
      (resp) => {
        this.setState({isRegistered: true});
        this.goBack();
      }, (err) => {
        this.setState({
          showPanel: true,
          errorMessage: "Requested not completed."
        });
      });
  }

  sendLostPassword() {
    this.setState({
      showPanel: false,
      emailError: false,
    })
    if (this.state.email  == '') {
      this.setState({
        showPanel: true,
        emailError: true,
        errorMessage: "Missing Data"
      });
      return;
    }
    if (!validator.isEmail( this.state.email )) {
      this.setState({
        showPanel: true,
        emailError: true,
        errorMessage: "Invalid Email"
      });
      return;
    }

    this.props.restMS.restRequest('lp', { email: this.state.email },
      (resp) => {
        this.setState({
          showPanel: true,
          emailSent: true,
          errorMessage: ""
        });
      },
      (err) => {
        console.log('Error');
        console.log(err);
        this.setState({
          showPanel: true,
          errorMessage: "Error to recover password."
        });
      });
  }

  goBack() {
    let fieldsValues = {};
    this.state.customFields.forEach((it) => {
      fieldsValues[it.name] = {value: "", error: false}
    });
    this.setState({
      screen: "initial",
      showPanel: true,
      emailSent: false,
      errorMessage: "",
      addCart: false,
      email: "",
      emailError: false,
      password: "",
      passwordError: false,
      customFieldsValues: fieldsValues,
      purchaseScreen: false,
    });
  }

  getExtraFields() {
    this.props.restMS.getRequest('sc',
      (resp) => {
        let fields = resp.success? resp.data: [];
        let fieldsValues = {};
        fields.forEach((it) => {
          fieldsValues[it.name] = {value: "", error: false}
        });
        this.setState({
          showPanel: true,
          customFields: fields,
          customFieldsValues: fieldsValues
        });
      },
      (err) => {
        this.setState({
          showPanel: true,
          customFields: [],
          customFieldsValues: {}
        });
      })
  }

  streamTitle() {
    if (!this.state.isLogged) {
      return (
        <h1>{this.props.streamName}</h1>
      );
    }
    const first = this.userData.first_name || '';
    const last = this.userData.last_name || '';
    const name = `${first} ${last}`.trim() || this.userData.email || '';
    return (
      <>
        <div className="titleDiv">
          <h1>{this.props.streamName}</h1>
        </div>
        <div className="accDiv item" tabIndex={0} role="button" aria-haspopup="true" aria-label="Account menu">
          <i className="icon user circle"></i>
          <span className="user_name">{name}</span>
          <div className="sub-menu">
            <div id="logout-btn" onClick={this.logOut} className="sub-menu-item">Log Out</div>
          </div>
        </div>
      </>
    );
  }

  viewStream() {
    this.setState({showPanel: false})
    this.props.loadPlayer();
  }

  registrationModal() {
    let title = this.streamTitle( );
    if (this.state.firstTime) {
      return (
        <div className='embv_login_wrapper'>
          <div className="stream_title">
            {title}
          </div>
          <div className="stream_body">
            <h1 className="emb-modal-heading">Registration Completed!</h1>
            <p className="emb-modal-text">You have successfully registered on {this.props.streamName}. To watch the stream click the button below.
            </p>
            <MsPanelButton id='view-streaming' label='View Stream'
                           onClickEvent={this.viewStream} classes="btn-primary alt" />
          </div>
        </div>
      );
    }
    return (
      <div className='embv_login_wrapper'>
        <div className="stream_title">
          {title}
        </div>
        <div className="stream_body">
          <p className="emb-modal-text">Click the button below to watch the stream.</p>
          <MsPanelButton id='view-streaming' label='View Stream'
                         onClickEvent={this.viewStream} classes="btn-primary alt" />
        </div>
      </div>
    );
  }

  buildRegistrationModal() {
    let title = this.streamTitle();
    return (
      <div className="embv_login_wrapper">
        <div className="stream_title">
          {title}
        </div>
        <div className="stream_body">
          <div className="information_place">
            {this.props.isEcommerce?
              <>
                <p>This stream is available for purchase.</p>
                { this.state.errorMessage.length > 0 && (
                  <div id="login-error" className="error-notification">{this.state.errorMessage}</div>
                )}
                <div className="ui three column grid">
                  <div className="column bold stream_name">{this.props.streamName}</div>
                  <div className="column emb-modal-price">{this.prodData.cur + this.prodData.price}</div>
                  <div className="column">
                    <MsPanelButton id='add-cart-submit' label='Add to Cart'
                                   onClickEvent={this.addToCart} classes="btn-primary alt" />
                  </div>
                </div>
              </>
            :
              <>
                <p>This stream is available for registration.</p>
                { this.state.errorMessage.length > 0 && (
                  <div id="login-error" className="error-notification">{this.state.errorMessage}</div>
                )}
                <div className="ui two column grid">
                  <div className="column bold not-mobile">{this.props.streamName}</div>
                  <div className="column">
                    <MsPanelButton id='register-submit' label='Register Now'
                                   onClickEvent={this.registerNow} classes="btn-primary alt" />
                  </div>
                </div>
              </>
            }
          </div>
          {!this.state.isLogged?
            <div className="extra_information_place">
              <p>If you already have {this.props.isEcommerce ? "purchased" : "registered"} just click <a id="login-acc-submit" className="login_link" onClick={this.loginLink}>Login</a>.
              </p>
            </div>
            :
            <></>
          }
        </div>
      </div>
    );
  }

  buildModal() {
    let component = this.state.isRegistered
      ? this.registrationModal()
      : this.buildRegistrationModal();

    return component;
  }

  buildLoginHeader() {
    let loginClass = this.state.screen === "login" ? "tab_section tab_selected" : "tab_section";
    let registerClass = this.state.screen === "register" ? "tab_section tab_selected" : "tab_section";
    let loginClick = this.state.screen === "register" ? this.showLogin : null;
    let registerClick = this.state.screen === "login" ? this.showRegister : null;
    return (
      <>
        <div className="header_section">
          <div className={loginClass} onClick={loginClick} >Login</div>
          <div className={registerClass} onClick={registerClick} >Create Account</div>
        </div>
        <div className="body_section">
          { this.state.errorMessage.length > 0 && (
              <div id="login-error" className="error-notification">{this.state.errorMessage}</div>
          )}
        </div>
        {this.state.addCart? <p style={{padding: "15px 30px 0px 30px", width: "100%"}}>Login required for this operation.</p> : <></>}
      </>
    )
  }

  buildLoginModal() {
    let title = this.buildLoginHeader()
    return (
      <div className='embv_login_wrapper'>
        {title}
        <div className="body_section" style={{padding: "0px 30px 24px 30px !important"}}>
          <div className="tab_body_section" data-login-tabbody="login" >
            <form name="checkout" method="post" className="checkout woocommerce-checkout">
              <input type="hidden" readOnly={true} name="submitaction" value="newuser_login" />
              <MsField id="login_email" label="Email Address" classes=""
                       value={this.state.email} onChange={this.setEmail}
                       showError={this.state.emailError}/>
              <MsField id="login_password" label="Password" classes="" type="password"
                       value={this.state.password} onChange={this.setPassword}
                       showError={this.state.passwordError}/>
              <div id="login-acc-captcha"></div>
              <p className="lost_password"><a id="lost-password" href="#" onClick={this.lostPassword}>Lost password?</a></p>
              <div className="login_buttons">
                <div className="leftFloat">
                  <MsPanelButton id='login-ms-submit' label='Login'
                                 onClickEvent={this.loginUser} classes="btn-primary alt" />
                </div>
                <div className="rightFloat">
                  <MsPanelButton id='back-ms-submit' label='Back'
                                 onClickEvent={this.goBack} classes="btn-primary alt" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  buildSingUpModal() {
    let title = this.buildLoginHeader()
    let customFields = [];
    this.state.customFields.forEach((it) => {
      customFields.push((<MsField id={it.name} key={it.name} label={it.label} classes=""
                       value={this.state.customFieldsValues[it.name].value} onChange={(newField) =>{
        this.setCustomField(newField, it.name);
        }} showError={this.state.customFieldsValues[it.name].error}/>));
    });
    return (
      <div className='embv_login_wrapper'>
        {title}
        <div className="body_section" style={{padding: "0px 30px 24px 30px !important"}}>
          <div className="tab_body_section" data-login-tabbody="register">
            <form id="create-acc-form" method="post">
              <input type="hidden" readOnly={true} name="submitaction" value="newuser_register" />
              <div className="fields_wrapper">
                <MsField id="first_name" label="First Name" classes=""
                         value={this.state.firstName} onChange={this.setFirstName}
                         showError={this.state.firstNameError} errorMsg={this.state.firstNameErrMsg}/>
                <MsField id="last_name" label="Last Name" classes=""
                         value={this.state.lastName} onChange={this.setLastName}
                         showError={this.state.lastNameError} errorMsg={this.state.lastNameErrMsg}/>
                <MsField id="email" label="Email address" classes=""
                         value={this.state.email} onChange={this.setEmail}
                         showError={this.state.emailError} errorMsg={this.state.emailErrMsg}/>
                <MsField id="password" label="Password" classes="" type="password"
                         value={this.state.password} onChange={this.setPassword}
                         showError={this.state.passwordError} errorMsg={this.state.passwErrMsg}/>
                {customFields}
              </div>
              <div id="reg-acc-captcha">
              </div>
              <div className="singup_buttons" style={{marginTop: "10px"}}>
                <div className="leftFloat">
                  <MsPanelButton id='create-ms-submit' label='Create Account'
                                 onClickEvent={this.createAccount} classes="btn-primary alt" />
                </div>
                <div className="rightFloat">
                  <MsPanelButton id='back-ms-submit' label='Back'
                                 onClickEvent={this.goBack} classes="btn-primary alt" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  buildLostPassword() {
    return (
      <div className='embv_login_wrapper'>
        <div className="stream_title">
          <h1>Lost Password</h1>
        </div>
        <div className="stream_body">
        {!this.state.emailSent ?
          <p className="subtitle">Please enter your email address to reset your password.</p>:
          <p className="subtitle">Please check your email and follow the password reset instructions. If you don’t receive a message in 5 minutes, check the junk folder.</p>
        }
          { this.state.errorMessage.length > 0 && (
                <div id="login-error" className="error-notification">{this.state.errorMessage}</div>
          )}
          <form id="lost-password-form" method="post">
            <div className="fields_wrapper">
              {!this.state.emailSent ?
                  <MsField id="login_email" label="Email Address" classes=""
                           value={this.state.email} onChange={this.setEmail}
                         showError={this.state.emailError}/>
                :<></>}
            </div>
            <div className="singup_buttons">
              <div className="leftFloat" style={{position: "relative"}}>
                <MsPanelButton id='lost-pass-submit' label='Submit'
                               onClickEvent={this.sendLostPassword} classes="btn-primary alt" />
              </div>
              <div className="rightFloat" style={{position: "relative"}}>
                <MsPanelButton id='back-ms-submit' label='Back'
                               onClickEvent={this.goBack} classes="btn-primary alt" />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  render() {
    if (!this.state.showPanel) {
      return (<MSStreamLoader
        divId="player_container_emb"
        width="100%"
        height="100%"
      />);
    }

    if (this.state.purchaseScreen && this.state.isLogged && this.token) {
      //console.log("jonas");
      //console.log(this.userData);
      return (<MSStreamPurchase
        prodData={this.prodData}
        streamName={this.props.streamName}
        backScreen={this.goBack}
        successScreen={this.viewStream}
        wcdata={this.wcData}
        userData={this.userData}
        restMS={this.props.restMS}
        token={this.token}
      />);
    }

    let component = null;
    switch (this.state.screen) {
      case "login":
        component = this.buildLoginModal();
        break;
      case "register":
        component = this.buildSingUpModal();
        break;
      case "lost-password":
        component = this.buildLostPassword();
        break;
      default:
        component = this.buildModal();
    }

    return (
      <div className="wpstream_login_backgorund">
        {component}
      </div>
    );
  }
}
export default injectIntl(MSStreamLogin);
